export default "__VITE_ASSET__BIVNARQN__"